import React from 'react';
import { useAuthState } from '@/plugins/Auth';

// TODO: refactor check auth feature once we refactor login/getToken API on Back-end.
const useAuth = () => {
  const { token, expiredTime } = useAuthState();

  const checkAuthenticated = React.useCallback(() => {
    if (
      !token
      || !expiredTime
      || expiredTime < new Date().getTime()
    ) return false;
    return true;
  }, [token, expiredTime]);

  return [checkAuthenticated];
};

export default useAuth;
